import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import classes from './GiftPost.module.css';
import Spinner from 'components/UI/Spinner/Spinner';

class GiftPost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listHeight: this.props.shortWindow ? 475.5 : 553.5,
      filterInput: '',
    };
  }

  componentDidUpdate(prevProps) {
    // resize scroll box height when selected giftees changes
    if (prevProps.gifteeMemberIds !== this.props.gifteeMemberIds) {
      const selectedGifteesContainer = document.getElementById('selectedGiftees');
      const listHeight =
        this.props.shortWindow === true ? 505.5 - selectedGifteesContainer.clientHeight : 583.5 - selectedGifteesContainer.clientHeight;
      this.setState({ listHeight });
    }
  }

  handleFilter = (event) => {
    const searchString = event.target.value;
    this.setState({ filterInput: searchString });
  };

  handleGifteesUpdate = (ids, names, isAdding, logIds) => {
    let updatedLogIds = logIds;
    // If user manually unchecks an individual (in tags or list) and they are a member of a checked log, then uncheck the log.
    // But do not remove other members of the log(s).
    if (ids.length === 1 && isAdding === false && logIds === undefined) updatedLogIds = this.logsWithMember(ids[0]);
    this.props.handleGifteesUpdate(ids, names, isAdding, updatedLogIds);
  };

  logsWithMember = (memberId) => {
    const filteredLogIds = [];
    this.props.logs.forEach((log) => {
      if (log.Users.filter((user) => user.UserId === memberId).length > 0) {
        filteredLogIds.push(log.Log.Id);
      }
    });
    return filteredLogIds;
  };

  handleLogsUpdate = (logId) => {
    const logMemberIds = [];
    const logMemberNames = [];
    let isAdding = false;
    let updatingLog = null;
    const selectLogsCombinedMemberIds = [];
    this.props.logs.forEach((log) => {
      if (log.Log.Id === logId) updatingLog = log;
      if (log.Users !== undefined && this.props.gifteeLogIds.includes(log.Log.Id))
        log.Users.forEach((user) => {
          if (this.props.postingAsUserId !== user.UserId) {
            selectLogsCombinedMemberIds.push(user.UserId);
          }
        });
    });

    isAdding = !this.props.gifteeLogIds.includes(logId);
    if (updatingLog.Users !== undefined && updatingLog.Users.length > 1) {
      updatingLog.Users.forEach((user) => {
        // Checking a log only adds names that are not already added.
        // Uncheck log removes names of members in log who are not in another checked log
        if (
          user.UserId !== this.props.postingAsUserId &&
          (isAdding || (!isAdding && selectLogsCombinedMemberIds.filter((memberId) => memberId === user.UserId).length < 2))
        ) {
          logMemberIds.push(user.UserId);
          logMemberNames.push(user.FirstName);
        }
      });
    }

    this.handleGifteesUpdate(logMemberIds, logMemberNames, isAdding, [logId]);
  };

  render = () => {
    let members = null;
    const logs = [];
    const selectedList = [];
    let gifteeList = null;

    if (this.props.members && this.props.members.length > 0) {
      members = [];
      const filteredMembers = [...this.props.members].filter(
        (user) =>
          ((user.User.FirstName && user.User.FirstName.toLowerCase().includes(this.state.filterInput.toLowerCase())) ||
            (user.User.LastName && user.User.LastName.toLowerCase().includes(this.state.filterInput.toLowerCase()))) &&
          user.User.UserId !== this.props.postingAsUserId,
      );
      filteredMembers.forEach((member) => {
        const isAdding = !this.props.gifteeMemberIds.includes(member.User.UserId);
        const memberItem = (
          <div
            className={[classes.ListItem, classes.Member].join(' ')}
            key={member.User.UserId}
            onClick={() => this.handleGifteesUpdate([member.User.UserId], [member.User.FirstName], isAdding)}
          >
            {`${member.User.FirstName} ${member.User.LastName}`}
            {this.props.gifteeMemberIds.includes(member.User.UserId) === true ? <FontAwesomeIcon icon="check" className={classes.CheckMark} /> : null}
          </div>
        );
        members.push(memberItem);
      });
    }

    if (this.props.logs && this.props.logs.length > 0) {
      const filteredLogs = [...this.props.logs].filter((log) => {
        const filteredMembers = log.Users.filter(
          (user) =>
            (user.FirstName && user.FirstName.toLowerCase().includes(this.state.filterInput.toLowerCase())) ||
            (user.LastName && user.LastName.toLowerCase().includes(this.state.filterInput.toLowerCase())),
        );
        return log.Log.Name.toLowerCase().includes(this.state.filterInput.toLowerCase()) || filteredMembers.length > 0;
      });

      filteredLogs.forEach((log) => {
        const userDisplayNames = [];
        log.Users.filter((user) => user.UserId !== this.props.postingAsUserId).forEach((user) => userDisplayNames.push(user.FirstName));
        const logsListItem = (
          <div className={[classes.ListItem, classes.Log].join(' ')} key={log.Log.Id} onClick={() => this.handleLogsUpdate(log.Log.Id)}>
            <div className={classes.LogName}>{log.Log.Name}</div>
            {log.Users && log.Users.length > 1 ? (
              <div className={classes.LogMembers}>{userDisplayNames.join(', ')}</div>
            ) : (
              <div className={classes.LogMembers} />
            )}
            {this.props.gifteeLogIds.includes(log.Log.Id) ? <FontAwesomeIcon icon="check" className={classes.CheckMark} /> : null}
          </div>
        );
        logs.push(logsListItem);
      });
    }

    if (this.props.gifteeMemberIds.length > 0) {
      this.props.gifteeMemberIds.forEach((memberId) => {
        const member = this.props.members.filter((m) => m.User.UserId === memberId)[0].User;
        const tag = (
          <span key={memberId} className={classes.Tag} onClick={() => this.handleGifteesUpdate([memberId], [member.FirstName], false)}>
            {member.FirstName}
            <FontAwesomeIcon icon="times" className={classes.UnselectMember} />
          </span>
        );
        selectedList.push(tag);
      });
    }

    if (this.props.loading === true) {
      gifteeList = <Spinner />;
    } else if (logs.length > 0 || members.length > 0) {
      gifteeList = (
        <div className={classes.GifteesList} style={{ height: `${this.state.listHeight}px` }}>
          {logs}
          {members}
        </div>
      );
    } else {
      gifteeList = <p className={classes.NoFilterResults}>There are no logs or members by that name</p>;
    }
    return (
      <div className={classes.LogSelectorContainer}>
        <p className={classes.SelectPrompt}>Select all people or log(s) you would like to send this gift to</p>
        <div id="selectedGiftees" className={classes.TagsInput}>
          <input
            className={classes.TagsFilterInput}
            placeholder="Enter name to filter the list below"
            onChange={(e) => this.handleFilter(e)}
            value={this.state.filterInput}
          />
          <div className={classes.Tags}>{selectedList}</div>
        </div>
        <div className={classes.AllLogsAndMembers}>
          <div className={classes.SelectorHeader}>
            <h3>Gift a copy to:</h3>
            <span className={classes.Clear} onClick={this.props.handleGifteesClear}>
              Clear
            </span>
          </div>
          {gifteeList}
        </div>
      </div>
    );
  };
}

export default GiftPost;
